import { Directive, inject } from '@angular/core';
import { NG_VALIDATORS, ValidatorFn } from '@angular/forms';
import { Validator, AbstractControl, ValidationErrors } from '@angular/forms';

import { HisValidatorAndMessage } from '../validator/his-validator-and-message';
import { HisDdValidatorFactory } from '../validator/his-dd-validator-factory';
import { DdEntryMerged } from '../model/data-dictionary';

/**
 * DataDictionary validator.
 */
@Directive( {
    selector: '[hisDdKey]',
    providers: [{ provide: NG_VALIDATORS, useExisting: HisDdValidator, multi: true }],
    standalone: false
} )
export class HisDdValidator implements Validator {
    private validatorFactory = inject(HisDdValidatorFactory);


    private validatorCalls: HisValidatorAndMessage[] = [];

    getValidators(): ValidatorFn[] {
        let vals: ValidatorFn[] = [];
        this.validatorCalls.forEach(
            ( val ) => {
                vals.push( val.getValidatorFn() );
            }
        );
        return vals;
    }

    registerValidators( ddEntry: DdEntryMerged ) {
        this.validatorCalls = [];

        // Erstellt einfache Validierungen über die ValidatorFactory, falls im DD konfiguriert
        this.createSimpleValidator( 'required', ddEntry.required );
        this.createSimpleValidator( 'minLength', ddEntry.minLength );
        this.createSimpleValidator( 'maxLength', ddEntry.maxLength );
        this.createSimpleValidator( 'minValueInteger', ddEntry.minValueInteger );
        this.createSimpleValidator( 'maxValueInteger', ddEntry.maxValueInteger );
        this.createSimpleValidator( 'minValueDouble', ddEntry.minValueDouble );
        this.createSimpleValidator( 'maxValueDouble', ddEntry.maxValueDouble );
        this.createSimpleValidator( 'minValueDate', ddEntry.minValueDate );
        this.createSimpleValidator( 'maxValueDate', ddEntry.maxValueDate );

        // regexValidation
        if ( ddEntry.regexPattern != null ) {
            let regex = ddEntry.regexPattern;

            // Der Pattern-Validator ergänzt selbst noch ^ am Anfang und $ am Ende
            if ( regex.startsWith( '^' ) ) {
                regex = regex.substring( 1 );
            }
            if ( regex.endsWith( '$' ) ) {
                regex = regex.slice( 0, -1 );
            }

            let call = this.validatorFactory.createValidator( 'pattern', regex );
            if ( ddEntry.regexErrortextIdentifier ) {
                call.messageKey = ddEntry.regexErrortextIdentifier;
            }
            this.validatorCalls.push( call );
        }

        // Datatype-Validation
        if ( ddEntry.datatype != null ) {
            let call = this.validatorFactory.createValidator( ddEntry.datatype, null );
            if ( call ) {
                this.validatorCalls.push( call );
            }
        }
    }

    private createSimpleValidator( ddAttributeName: string, ddAttributeValue: string | number | boolean ) {
        if ( ddAttributeValue != null && ddAttributeValue !== false ) {
            let call = this.validatorFactory.createValidator( ddAttributeName, ddAttributeValue );
            this.validatorCalls.push( call );
        }
    }

    /**
     * Führt die oben erzeugten DD-Validierungen aus.
     */
    validate( c: AbstractControl ): ValidationErrors {
        for ( let call of this.validatorCalls ) {
            let state = call.validate( c );
            if ( state ) {
                return state;
            }
        }

        return null;
    }
}
